// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__jwMLl","paramInput":"JobSimulator_paramInput__11j6o","input":"JobSimulator_input__3ilaC"};